import { render, staticRenderFns } from "./story.vue?vue&type=template&id=3f23dc6a&"
import script from "./story.vue?vue&type=script&lang=js&"
export * from "./story.vue?vue&type=script&lang=js&"
import style0 from "./story.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports